var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('web-form',{key:_vm.componentKey,attrs:{"to-re-render":""},on:{"form-submitted":_vm.forceRerender}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }